<template>
  <div name="access">

       <section class="card form">
      <div class="card-heading border bottom">
          <h4 class="card-title">{{title}}</h4>
       </div>
                        <p >
                         {{message}}
                          </p>



                          <p>
                          If you wish to discuss / upgrade your current access to more features such as custom outcomes or full custom curriculum entries please contact us below. 
                        </p>
                        <p>
                          <strong>
                          You can contact us using the <router-link to="contact">Contact Form</router-link> or<br/><br/>

                          <ul>
                            <li>Email: <a href="mailto:info@primarypepassport.co.uk">info@primarypepassport.co.uk</a> </li>
                            <li>Telephone: 0800 055 6550 </li>
                          </ul>
                        </strong>
                        </p>

         </section>
  </div>
</template>

<script>
export default {
  name: "access",
  props: ['blocktype'],
  computed: {
    title () {
      if (this.blocktype == 'unit') {
        return "You have used all avilable FREE Custom Units"
      } else if (this.blocktype == 'outcome') {
        return "You do not have access to the custom Outcome module"
      }
    },
    message () {
      if (this.blocktype == 'unit') {
        return "All full customers get 12 FREE custom units to use within our system"
       } else if (this.blocktype == 'outcome') {
        return "To add custom outcomes requires an upgrade to your account."
      }

      
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

a {
  color: #fff !important;
  opacity: 0.8 !important;
  text-transform: underline !important;
}

.card {
  background-color: #f56a6a !important;
  color: #fff !important;
}

.card .card-title, .card strong {
  color: #fff;
}

</style>